import { useIsFocused } from 'expo-router';
import type { VideoPlayer } from 'expo-video';
import { useEffect } from 'react';

/**
 * Play a reel only while its screen is focused — the screens stay mounted under
 * whatever is pushed on top of them, so the video (and its audio, once unmuted)
 * has to be stopped by hand. Mute is left as the reader set it.
 *
 * The pause is in the effect BODY, with no cleanup, deliberately: `useVideoPlayer`
 * releases the native player in its own unmount cleanup, registered before ours,
 * so a later cleanup would `pause()` a dead SharedObject and throw. A body only
 * runs on a render, i.e. while the player is still alive.
 */
export function usePlayWhileFocused(player: VideoPlayer) {
  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused) player.play();
    else player.pause();
  }, [isFocused, player]);
}
